/**
 * Admin footer (Oct 2026): which commit the website and the server functions
 * were built from, and a warning when the server is missing changes the
 * website already has — i.e. the functions deploy (GitHub → "Deploy hub
 * functions", approval-gated) hasn't run yet for the newest server change.
 */
import { useEffect, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { CALLABLES, type HubBuildInfo } from '@daaily/shared';
import { functions } from '../lib/firebase';

const callHubVersion = httpsCallable<Record<string, never>, { server: HubBuildInfo | null }>(functions, CALLABLES.HUB_VERSION);
const ACTIONS_URL = 'https://github.com/DAAily/daaily-hr-hub/actions/workflows/deploy-functions.yml';

const short = (sha: string) => sha.slice(0, 7);
const when = (iso: string | null) => (iso ? new Date(iso).toLocaleString('en-GB', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '–');
const t = (iso: string | null) => (iso ? new Date(iso).getTime() : 0);

export function VersionInfo() {
  const web = __HUB_BUILD__;
  const [server, setServer] = useState<HubBuildInfo | null | undefined>(undefined);
  useEffect(() => {
    callHubVersion({}).then((r) => setServer(r.data.server), () => setServer(null));
  }, []);

  // Behind = the server was built from a commit OLDER than the newest server
  // change the website knows about.
  const behind = !!server && t(server.commitTime) < t(web.lastServerChangeTime);

  return (
    <div className="pt-6 mt-6 border-t border-line text-xs text-fg-faint space-y-1">
      <div>
        Website <span className="font-mono">{short(web.commit)}</span> ({when(web.commitTime)})
        {' · '}
        Server {server === undefined ? '…' : server ? <><span className="font-mono">{short(server.commit)}</span> ({when(server.commitTime)})</> : 'unknown'}
      </div>
      {behind && (
        <div className="text-warning">
          The server is missing changes from <span className="font-mono">{short(web.lastServerChange)}</span> ({when(web.lastServerChangeTime)}).{' '}
          <a href={ACTIONS_URL} target="_blank" rel="noreferrer" className="underline">Approve the functions deploy in GitHub</a>.
        </div>
      )}
    </div>
  );
}
